import {
  parseISO,
  isValid,
  format,
  parse,
  isToday,
  isYesterday,
  isThisYear,
  isThisMonth,
  isThisWeek,
  subWeeks,
  subMonths,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
} from 'date-fns';

export function processDate(dateStr: string, type: 'api' | 'ui' = 'ui') {
  // check if date is valid
  const date = parseISO(dateStr);
  if (isValid(date)) {
    const formattedDate = format(
      date,
      type === 'api' ? 'yyyy-MM-dd' : 'dd MMM yyyy',
    );
    return { isValid: isValid(date), date, formattedDate };
  } else {
    return { isValid: false, date: null, formattedDate: null };
  }
}

export function processDateString(dateStr: string) {
  // dateStr= 28 Mar 2025
  return parse(dateStr, 'dd MMM yyyy', new Date());
}

export const formatLocalDate = (date: Date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export function getLastNFinancialYears(n: number = 5): string[] {
  const today = new Date();

  const FY_START_MONTH = 3;

  const currentFYStartYear =
    today.getMonth() >= FY_START_MONTH
      ? today.getFullYear()
      : today.getFullYear() - 1;

  return Array.from({ length: n }, (_, index) => {
    const startYear = currentFYStartYear - index;
    const endYear = startYear + 1;

    return `${startYear}-${endYear}`;
  });
}

export function isLastMonth(date: Date) {
  const now = new Date();

  const firstDayOfLastMonth = startOfMonth(subMonths(now, 1));

  const lastDayOfLastMonth = endOfMonth(subMonths(now, 1));

  return date >= firstDayOfLastMonth && date <= lastDayOfLastMonth;
}

export function sortByDate<T>(array: T[] = [], dateKey: string) {
  const dateGroupedPendingTasks: Record<string, T[]> = {};

  array?.forEach((element) => {
    // @ts-expect-error ignore
    const date = new Date(element?.[dateKey]);
    const isItToday = isToday(date);
    const isItYesterday = isYesterday(date);
    const isItThisWeek = isThisWeek(date);
    const isItLastWeek = isLastWeek(date);
    const isItThisMonth = isThisMonth(date);
    const isItLastMonth = isLastMonth(date);
    const isItThisYear = isThisYear(date);

    if (date) {
      if (isItToday) {
        dateGroupedPendingTasks['Today'] = [
          ...(dateGroupedPendingTasks['Today'] || []),
          element,
        ];
      } else if (isItYesterday) {
        dateGroupedPendingTasks['Yesterday'] = [
          ...(dateGroupedPendingTasks['Yesterday'] || []),
          element,
        ];
      } else if (isItThisWeek) {
        dateGroupedPendingTasks['This Week'] = [
          ...(dateGroupedPendingTasks['This Week'] || []),
          element,
        ];
      } else if (isItLastWeek) {
        dateGroupedPendingTasks['Last Week'] = [
          ...(dateGroupedPendingTasks['Last Week'] || []),
          element,
        ];
      } else if (isItThisMonth) {
        dateGroupedPendingTasks['This Month'] = [
          ...(dateGroupedPendingTasks['This Month'] || []),
          element,
        ];
      } else if (isItLastMonth) {
        dateGroupedPendingTasks['Last Month'] = [
          ...(dateGroupedPendingTasks['Last Month'] || []),
          element,
        ];
      } else if (isItThisYear) {
        dateGroupedPendingTasks['This Year'] = [
          ...(dateGroupedPendingTasks['This Year'] || []),
          element,
        ];
      } else {
        dateGroupedPendingTasks['Before This Year'] = [
          ...(dateGroupedPendingTasks['Before This Year'] || []),
          element,
        ];
      }
    }
  });
  return dateGroupedPendingTasks;
}
export function isLastWeek(date: Date) {
  const now = new Date();

  const firstDayOfLastWeek = startOfWeek(subWeeks(now, 1));

  const lastDayOfLastWeek = endOfWeek(subWeeks(now, 1));

  return date >= firstDayOfLastWeek && date <= lastDayOfLastWeek;
}
